import React from 'react';

import {
  AccountInfoResult,
  DelegatorRewardResult,
} from '@block-explorer/entities';
import {
  FlexRow,
  TableData,
  TableRow,
  DEFAULT_AMOUNT_PRECISION,
} from '@make-software/cspr-design';
import { BodyText, formatTimestamp } from '@block-explorer/ui';

import {
  CsprAmount,
  motesToCurrency,
  TableDataAccountInfo,
} from '../../../components';
import FiatCurrency from '../../../components/multi-currency/multi-currency';
import { PrecisionCase } from '../../../utils/currency';
import { deriveAccountInfo } from '../../../utils/account.tsx';

interface RewardListItemProps {
  loading: boolean;
  accountInfo: AccountInfoResult | undefined;
  data?: DelegatorRewardResult;
  onClick?: (id: number) => void;
  currencyRate: number | undefined;
}

export const AccountRewardListItem = ({
  loading,
  data,
  accountInfo,
  currencyRate,
}: RewardListItemProps) => {
  const accountInfoDetails = deriveAccountInfo(
    accountInfo?.account_info || accountInfo?.centralized_account_info
  );
  const logo = accountInfoDetails && accountInfoDetails?.logo;
  const name = accountInfoDetails?.name;

  const currencyAmount =
    data?.amount && data?.rate
      ? motesToCurrency(data?.amount, data?.rate)
      : null;
  const currentCurrencyAmount =
    data && currencyRate ? motesToCurrency(data?.amount, currencyRate) : null;

  return (
    <TableRow>
      <TableData>
        <BodyText size={3} variation="darkGray">
          {data?.era_id}
        </BodyText>
      </TableData>
      <TableData>
        <BodyText size={3} variation="darkGray" noWrap loading={loading}>
          {data && formatTimestamp(data.timestamp)}
        </BodyText>
      </TableData>
      <TableData>
        <FlexRow align="center" itemsSpacing={10}>
          {data && (
            <TableDataAccountInfo
              validatorAccount
              logo={logo}
              name={name}
              publicKey={data?.validator_public_key}
              loading={!data}
              csprName={accountInfo?.cspr_name}
            />
          )}
        </FlexRow>
      </TableData>
      <TableData align={'right'}>
        <BodyText size={3} monotype noWrap loading={loading}>
          {data && (
            <CsprAmount
              motes={data?.amount}
              precisionCase={PrecisionCase.deployCost}
            />
          )}
        </BodyText>
      </TableData>
      <TableData align={'right'}>
        <BodyText size={3} monotype noWrap loading={loading}>
          {data && (
            <FiatCurrency
              amount={currencyAmount}
              precision={DEFAULT_AMOUNT_PRECISION}
            />
          )}
        </BodyText>
      </TableData>
      <TableData align={'right'}>
        <BodyText size={3} monotype noWrap loading={loading}>
          {data && (
            <FiatCurrency
              amount={currentCurrencyAmount}
              precision={DEFAULT_AMOUNT_PRECISION}
            />
          )}
        </BodyText>
      </TableData>
    </TableRow>
  );
};

export default AccountRewardListItem;
